// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveDesignPackageMutationVariables = Types.Exact<{
  input: Types.SaveDesignPackageInput;
}>;


export type SaveDesignPackageMutation = { __typename?: 'Mutation', saveDesignPackage: { __typename?: 'SaveDesignPackageResult', designPackage: { __typename?: 'DesignPackage', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string } } } };


export const SaveDesignPackageDocument = gql`
    mutation SaveDesignPackage($input: SaveDesignPackageInput!) {
  saveDesignPackage(input: $input) {
    designPackage {
      id
      status {
        code
        name
      }
    }
  }
}
    `;
export type SaveDesignPackageMutationFn = Apollo.MutationFunction<SaveDesignPackageMutation, SaveDesignPackageMutationVariables>;

/**
 * __useSaveDesignPackageMutation__
 *
 * To run a mutation, you first call `useSaveDesignPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDesignPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDesignPackageMutation, { data, loading, error }] = useSaveDesignPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDesignPackageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDesignPackageMutation, SaveDesignPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDesignPackageMutation, SaveDesignPackageMutationVariables>(SaveDesignPackageDocument, options);
      }
export type SaveDesignPackageMutationHookResult = ReturnType<typeof useSaveDesignPackageMutation>;
export type SaveDesignPackageMutationResult = Apollo.MutationResult<SaveDesignPackageMutation>;
export type SaveDesignPackageMutationOptions = Apollo.BaseMutationOptions<SaveDesignPackageMutation, SaveDesignPackageMutationVariables>;